(function () {
  'use strict';

  /*
   * Võti on Zepto algne data-value.
   * Kood muudab ainult kliendile nähtavat teksti.
   */
  const translations = {
    '⚜ Lions': {
      en: '⚜ Lions',
      et: '⚜ Lõvid',
      lv: '⚜ Lauvas',
      lt: '⚜ Liūtai',
      fi: '⚜ Leijonat',
      ru: '⚜ Львы'
    },

    '🐺 Wolves': {
      en: '🐺 Wolves',
      et: '🐺 Hundid',
      lv: '🐺 Vilki',
      lt: '🐺 Vilkai',
      fi: '🐺 Sudet',
      ru: '🐺 Волки'
    },

    '𝔈𝔖𝔗 Legion': {
      en: '𝔈𝔖𝔗 Legion',
      et: '𝔈𝔖𝔗 Leegion',
      lv: '𝔈𝔖𝔗 Leģions',
      lt: '𝔈𝔖𝔗 Legionas',
      fi: '𝔈𝔖𝔗 Legioona',
      ru: '𝔈𝔖𝔗 Легион'
    },

    '🇪🇪 Estonia Outline': {
      en: '🇪🇪 Estonia Outline',
      et: '🇪🇪 Eesti kontuur',
      lv: '🇪🇪 Igaunijas kontūra',
      lt: '🇪🇪 Estijos kontūras',
      fi: '🇪🇪 Viron ääriviivat',
      ru: '🇪🇪 Контур Эстонии'
    },

    '〰 Wave': {
      en: '〰 Wave',
      et: '〰 Laine',
      lv: '〰 Vilnis',
      lt: '〰 Banga',
      fi: '〰 Aalto',
      ru: '〰 Волна'
    },

    '🦊 Fox': {
      en: '🦊 Fox',
      et: '🦊 Rebane',
      lv: '🦊 Lapsa',
      lt: '🦊 Lapė',
      fi: '🦊 Kettu',
      ru: '🦊 Лиса'
    },

    '⚔ Fighters': {
      en: '⚔ Fighters',
      et: '⚔ Väike Tõll',
      lv: '⚔ Cīnītāji',
      lt: '⚔ Kovotojai',
      fi: '⚔ Taistelijat',
      ru: '⚔ Бойцы'
    },

    'ϟ Thunder Cross': {
      en: 'ϟ Thunder Cross',
      et: 'ϟ Kõuerist',
      lv: 'ϟ Pērkona krusts',
      lt: 'ϟ Perkūno kryžius',
      fi: 'ϟ Ukkosenristi',
      ru: 'ϟ Громовой крест'
    },

    '✣ Ancient Tree': {
      en: '✣ Ancient Tree',
      et: '✣ Iidne puu',
      lv: '✣ Austras koks',
      lt: '✣ Senovinis medis',
      fi: '✣ Muinainen puu',
      ru: '✣ Древнее дерево'
    },

    'Ⓜ Monogram': {
      en: 'Ⓜ Monogram',
      et: 'Ⓜ Monogramm',
      lv: 'Ⓜ Monogramma',
      lt: 'Ⓜ Monograma',
      fi: 'Ⓜ Monogrammi',
      ru: 'Ⓜ Монограмма'
    },

    '✷ Zodiac': {
      en: '✷ Zodiac',
      et: '✷ Tähtkujud',
      lv: '✷ Zodiaka zīmes',
      lt: '✷ Zodiako ženklai',
      fi: '✷ Horoskooppimerkit',
      ru: '✷ Знаки зодиака'
    },

    '☀ Tree of Dawn': {
      en: '☀ Tree of Dawn',
      et: '☀ Koidupuu',
      lv: '☀ Austras koks',
      lt: '☀ Aušros medis',
      fi: '☀ Aamunkoiton puu',
      ru: '☀ Древо рассвета'
    },

    '🇱🇹 Gediminas Tower': {
      en: '🇱🇹 Gediminas Tower',
      et: '🇱🇹 Gediminase torn',
      lv: '🇱🇹 Ģedimina tornis',
      lt: '🇱🇹 Gedimino pilies bokštas',
      fi: '🇱🇹 Gediminasin torni',
      ru: '🇱🇹 Башня Гедимина'
    },

'🐅Tiger': {
  en: '🐅Tiger',
  et: '🐅Tiiger',
  lv: '🐅Tīģeris',
  lt: '🐅Tigras',
  fi: '🐅Tiikeri',
  ru: '🐅Тигр'
},

'♡ Love': {
  en: '♡ Love',
  et: '♡ Armastus',
  lv: '♡ Mīlestība',
  lt: '♡ Meilė',
  fi: '♡ Rakkaus',
  ru: '♡ Любовь'
},

'Initials': {
  en: 'Initials',
  et: 'Initsiaalid',
  lv: 'Iniciāļi',
  lt: 'Inicialai',
  fi: 'Nimikirjaimet',
  ru: 'Инициалы'
},

    '♈ Jäär / Aries': {
      en: '♈ Aries',
      et: '♈ Jäär',
      lv: '♈ Auns',
      lt: '♈ Avinas',
      fi: '♈ Oinas',
      ru: '♈ Овен'
    },

    '♉ Sõnn / Taurus': {
      en: '♉ Taurus',
      et: '♉ Sõnn',
      lv: '♉ Vērsis',
      lt: '♉ Jautis',
      fi: '♉ Härkä',
      ru: '♉ Телец'
    },

    '♊ Kaksikud / Gemini': {
      en: '♊ Gemini',
      et: '♊ Kaksikud',
      lv: '♊ Dvīņi',
      lt: '♊ Dvyniai',
      fi: '♊ Kaksoset',
      ru: '♊ Близнецы'
    },

    '♋ Vähk / Cancer': {
      en: '♋ Cancer',
      et: '♋ Vähk',
      lv: '♋ Vēzis',
      lt: '♋ Vėžys',
      fi: '♋ Rapu',
      ru: '♋ Рак'
    },

    '♌ Lõvi / Leo': {
      en: '♌ Leo',
      et: '♌ Lõvi',
      lv: '♌ Lauva',
      lt: '♌ Liūtas',
      fi: '♌ Leijona',
      ru: '♌ Лев'
    },

    '♍ Neitsi / Virgo': {
      en: '♍ Virgo',
      et: '♍ Neitsi',
      lv: '♍ Jaunava',
      lt: '♍ Mergelė',
      fi: '♍ Neitsyt',
      ru: '♍ Дева'
    },

    '♎ Kaalud / Libra': {
      en: '♎ Libra',
      et: '♎ Kaalud',
      lv: '♎ Svari',
      lt: '♎ Svarstyklės',
      fi: '♎ Vaaka',
      ru: '♎ Весы'
    },

    '♏ Skorpion / Scorpio': {
      en: '♏ Scorpio',
      et: '♏ Skorpion',
      lv: '♏ Skorpions',
      lt: '♏ Skorpionas',
      fi: '♏ Skorpioni',
      ru: '♏ Скорпион'
    },

    '♐ Ambur / Sagittarius': {
      en: '♐ Sagittarius',
      et: '♐ Ambur',
      lv: '♐ Strēlnieks',
      lt: '♐ Šaulys',
      fi: '♐ Jousimies',
      ru: '♐ Стрелец'
    },

    '♑ Kaljukits / Capricorn': {
      en: '♑ Capricorn',
      et: '♑ Kaljukits',
      lv: '♑ Mežāzis',
      lt: '♑ Ožiaragis',
      fi: '♑ Kauris',
      ru: '♑ Козерог'
    },

    '♒ Veevalaja / Aquarius': {
      en: '♒ Aquarius',
      et: '♒ Veevalaja',
      lv: '♒ Ūdensvīrs',
      lt: '♒ Vandenis',
      fi: '♒ Vesimies',
      ru: '♒ Водолей'
    },

    '♓ Kalad / Pisces': {
      en: '♓ Pisces',
      et: '♓ Kalad',
      lv: '♓ Zivis',
      lt: '♓ Žuvys',
      fi: '♓ Kalat',
      ru: '♓ Рыбы'
    },

    'With spacing between the letters, you can stretch the text.': {
      en: 'By adding spaces between the letters, you can stretch the text wider.',
      et: 'Tähtede vahele tühikuid pannes saad teksti laiemaks venitada.',
      lv: 'Ievietojot atstarpes starp burtiem, tekstu var izstiept platāku.',
      lt: 'Įterpdami tarpus tarp raidžių, galite ištempti tekstą plačiau.',
      fi: 'Lisäämällä välilyöntejä kirjainten väliin voit venyttää tekstiä leveämmäksi.',
      ru: 'Добавляя пробелы между буквами, можно растянуть текст по ширине.'
    },

    'Use the -/+ controls to change the text size. Add spaces between the letters to stretch the text.': {
      en: 'Use the -/+ controls to change the text size. Add spaces between the letters to stretch the text.',
      et: '-/+ märkidega saad teksti suurust muuta. Tähtede vahele tühikuid pannes saad teksti laiemaks venitada.',
      lv: 'Ar -/+ pogām vari mainīt teksta izmēru. Ievietojot atstarpes starp burtiem, vari tekstu izstiept platāku.',
      lt: 'Naudodami -/+ mygtukus galite keisti teksto dydį. Įterpdami tarpus tarp raidžių, galite ištempti tekstą plačiau.',
      fi: 'Muuta tekstin kokoa -/+ painikkeilla. Lisää välilyöntejä kirjainten väliin venyttääksesi tekstiä leveämmäksi.',
      ru: 'Изменяйте размер текста кнопками -/+. Добавляйте пробелы между буквами, чтобы растянуть текст по ширине.'
    },

    'Enter your zodiac sign and/or your name.': {
      en: 'Enter your zodiac sign and/or your name.',
      et: 'Sisesta oma tähtkuju ja/või nimi.',
      lv: 'Ievadi savu zodiaka zīmi un/vai vārdu.',
      lt: 'Įveskite savo zodiako ženklą ir (arba) vardą.',
      fi: 'Kirjoita horoskooppimerkkisi ja/tai nimesi.',
      ru: 'Введите свой знак зодиака и/или имя.'
    },

    'Use the −/+ controls to change the Monogram size.': {
      en: 'Use the −/+ controls to change the Monogram size.',
      et: 'Monogrammi suuruse muutmiseks kasuta −/+ nuppe.',
      lv: 'Izmanto −/+ pogas, lai mainītu monogrammas izmēru.',
      lt: 'Naudokite −/+ mygtukus monogramos dydžiui pakeisti.',
      fi: 'Muuta monogrammin kokoa −/+ painikkeilla.',
      ru: 'Изменяйте размер монограммы кнопками −/+.'
    },

    'Text 2': {
      en: 'Text 2',
      et: 'Tekst 2',
      lv: 'Teksts 2',
      lt: 'Tekstas 2',
      fi: 'Teksti 2',
      ru: 'Текст 2'
    }
  };

  function normalizeText(value) {
    return String(value || '')
      .replace(/[\uFE0E\uFE0F]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getStoreLanguage() {
    const language =
      document.documentElement.getAttribute('lang') || 'en';

    return language.toLowerCase().split('-')[0];
  }

  function translateZeptoOptions() {
    const language = getStoreLanguage();

    document
      .querySelectorAll('.pplr-drop-item[data-value]')
      .forEach(function (option) {
        const originalValue = normalizeText(
          option.getAttribute('data-value')
        );

        const translation = translations[originalValue];

        if (!translation) return;

        const translatedValue =
          translation[language] || translation.en;

        if (
          translatedValue &&
          option.textContent.trim() !== translatedValue
        ) {
          option.textContent = translatedValue;
        }
      });
  }

  function translateZeptoPopup() {
    const language = getStoreLanguage();

    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT
    );

    const textNodes = [];
    let node;

    while ((node = walker.nextNode())) {
      textNodes.push(node);
    }

    textNodes.forEach(function (textNode) {
      const parent = textNode.parentElement;

      if (
        !parent ||
        parent.matches('script, style, noscript')
      ) {
        return;
      }

      const originalValue = normalizeText(
        textNode.nodeValue
      );

      const translation = translations[originalValue];

      if (!translation) return;

      const translatedValue =
        translation[language] || translation.en;

      if (
        translatedValue &&
        textNode.nodeValue !== translatedValue
      ) {
        textNode.nodeValue = translatedValue;
      }
    });
  }

  function initializeLocalization() {
    translateZeptoOptions();
    translateZeptoPopup();

    let localizationTimer;

    const observer = new MutationObserver(function () {
      clearTimeout(localizationTimer);

      localizationTimer = setTimeout(function () {
        translateZeptoOptions();
        translateZeptoPopup();
      }, 150);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeLocalization
    );
  } else {
    initializeLocalization();
  }

  document.addEventListener(
    'pplrAppInitiated',
    function () {
      translateZeptoOptions();
      translateZeptoPopup();
    }
  );
})();